import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Button } from '../../Button/Button.js';
import { DialogWithDoubleEscape, useDialogClose } from './DialogWithDoubleEscape.js';
import { Icon } from '../../Icon/Icon.js';

function ConfirmDialog(_ref) {
  let {
    title,
    children,
    onClose,
    buttons,
    loading,
    onSubmit
  } = _ref;
  function ButtonsContent() {
    var _a, _b;
    const close = useDialogClose();
    const buttonsTemplate = jsxs(Fragment, {
      children: [jsx(Button, {
        label: "Cancel",
        severity: "secondary",
        onClick: close
      }), jsx(Button, {
        label: (_a = buttons === null || buttons === void 0 ? void 0 : buttons.submitLabel) !== null && _a !== void 0 ? _a : 'Confirm',
        loading: loading,
        onClick: () => {
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
      })]
    });
    return jsx("div", {
      className: "flex flex-row justify-content-center mt-5",
      children: jsxs("div", {
        className: "flex flex-row gap-2",
        children: [(_b = buttons === null || buttons === void 0 ? void 0 : buttons.content) !== null && _b !== void 0 ? _b : null, !(buttons === null || buttons === void 0 ? void 0 : buttons.content) && buttonsTemplate]
      })
    });
  }
  function HeaderContent() {
    const close = useDialogClose();
    return jsxs("div", {
      className: "flex flex-row justify-content-between",
      children: [jsx("div", {
        className: "flex align-items-center",
        children: title
      }), jsx(Button, {
        icon: jsx(Icon, {
          name: "cancel",
          fontSize: "normal"
        }),
        rounded: true,
        text: true,
        onClick: close
      })]
    });
  }
  return jsxs(DialogWithDoubleEscape, {
    onClose: onClose,
    className: "dialog-confirm",
    header: jsx(HeaderContent, {}),
    children: [children, jsx(ButtonsContent, {})]
  });
}

export { ConfirmDialog };
